export const getCustomerFields = (
  companyList,
  selectedCompanyLocations,
  phibroRepOptions,
  customerForm,
  editMode
) => {
  const fields = [
    {
      name: "masterCompanyId",
      label: "Master Company Name",
      type: "select",
      placeholder: "Select Master Company Name",
      validations: ["required"],
      searchable: true,
      searchPlaceholder: "Search Company",
      options: companyList.map((c) => ({ label: c.name, value: c.companyId })),
      colSize: { lg: 6, md: 6, sm: 12 },
    },
    {
      name: "masterLocationId",
      label: "Master Location",
      type: "select",
      placeholder: "Select Master Location",
      validations: ["required"],
      options: (selectedCompanyLocations || []).map((loc) => ({
        label: loc.name,
        value: loc.locationId,
      })),
      colSize: { lg: 6, md: 6, sm: 12 },
    },
    {
      name: "masterSalesRepName",
      label: "Master Sales Rep",
      type: "text",
      disabled: true,
      validations: [],
      placeholder: "Auto selected based on location",
      colSize: { lg: 12, md: 12, sm: 12 },
    },
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
      disabled: true,
      validations: ["required"],
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "location",
      label: "Location",
      type: "text",
      disabled: true,
      validations: ["required"],
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      placeholder: "Enter Address",
      disabled: true,
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      disabled: true,
      placeholder: "Enter Country",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "state",
      label: "State",
      type: "text",
      disabled: true,
      placeholder: "Enter State",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      disabled: true,
      placeholder: "Enter City",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "zipCode",
      label: "Zip Code",
      type: "text",
      disabled: true,
      placeholder: "Enter Zip Code",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "phone",
      label: "Phone",
      type: "text",
      disabled: true,
      placeholder: "Enter Phone",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "fax",
      label: "Fax",
      type: "text",
      disabled: true,
      placeholder: "Enter Fax",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "firstName",
      label: "First Name",
      validations: ["required"],
      type: "text",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "lastName",
      label: "Last Name",
      validations: ["required"],
      type: "text",
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      validations: ["required"],
      colSize: { lg: 4, md: 4, sm: 12 },
    },
    {
      name: "registrationDate",
      label: "Registered Date",
      type: "text",
      disabled: true,
      colSize: { lg: 4, md: 4, sm: 12 },
    },
  ];
  if (editMode==="customer") {
    return fields;
  }
  return fields.filter((field) => field.name !== "registrationDate");
};
